import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable } from "rxjs";
import { ContactAddress, DeliveryAddress, singleCustomer } from "../customer-search/customer-search.component";
import * as api from '../../shared/api/apihandler';

export class AddressSupport {
    constructor(private http: HttpClient) {}

    getCustomerAddress(id){
        const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') });
        return new Observable((observer)=> {
            this.http.get(api.jubloApi + 'api/Website/Customer/GetCustomerById/' + id, { headers }).subscribe(
                (data:singleCustomer)=> {
                    observer.next(this.SingleCustomerToAddresses(data));
                    observer.complete();
                },
                (err)=>{
                    observer.next(err);
                    observer.complete();
                }
            )

        })
    }

    getCompanyAddress(id){
        const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') });
        return new Observable((observer)=> {
            this.http.get(api.jubloApi + 'api/Assets/GetCompanyInfo/'+id,{ headers }).subscribe(
                (data)=> { 
                    observer.next( this.companyInfoToAddress(data) );
                    observer.complete();
                },
                (err) => {
                    observer.next(err);
                    observer.complete();
                }
            )

        })
    }

    private SingleCustomerToAddresses(c:singleCustomer):SingleCustomerAddresses{
        let del = !!c.deliveryId ? this.singleCustomerDeliveryToAddress(c.addresses.find(x => x.deliveryId == c.deliveryId)) : null;
        let con = !!c.contactId ? this.singleCustomerContactToAddress(c.contactAddresse.find(x => x.id == c.contactId)) : null;
        return {
            invoice:{
                id: c.customerId,
                name: c.invoiceName,
                address:c.invoiceAddress,
                zipcode:c.invoiceZipCode,
                city:c.invoiceCity,
                phone:c.invoicePhone,
                mobile:c.invoiceMobile,
                email: c.invoiceEmail
            },
            customer:{
                id:c.customerId,
                name: c.customerName,
                address: c.customerAddress,
                zipcode: c.customerZipCode,
                city: c.customerCity,
                phone: c.customerPhone,
                mobile: c.customerMobile,
                email: c.customerMail
            },
            delivery: del,
            contact:{},
            deliveries:c.addresses.map(x => this.singleCustomerDeliveryToAddress(x)),
            contacts:c.contactAddresse.map(x => this.singleCustomerContactToAddress(x))
        }
    }
    
    private singleCustomerDeliveryToAddress(d:DeliveryAddress): SingleAddress {
        if(!d) return null
        return {
            id: d.deliveryId,
            name: d.customerName,
            address: d.customerAddress,
            zipcode: d.customerZipCode,
            city: d.customerCity,
            phone:d.customerPhone,
            mobile: d.customerMobile,
            email: d.customerMail
        }
    }

    private singleCustomerContactToAddress(c:ContactAddress): SingleAddress {
        if(!c) return null
        return {
            id: c.id,
            name: c.name,
            address: c.address,
            zipcode: c.zipCode,
            city: c.city,
            phone: c.phone,
            mobile: c.mobile,
            email: c.email,
            ean: c.ean,
            fax: c.fax,
            cvr: c.cvr
        }
    }

    private companyInfoToAddress(c): SingleAddress{
        return {
            name: c.companyName,
            address: c.address,
            zipcode: c.zipCode,
            city: c.city,
            phone: c.phone,
            email: c.email,
            logo : c.logo
        }
    }
}

class SingleCustomerAddresses {
    invoice: SingleAddress;
    customer: SingleAddress;
    delivery: SingleAddress;
    contact: SingleAddress;
    deliveries: SingleAddress[];
    contacts: SingleAddress[];
}


export class SingleAddress {
    id?: string;
    name?: string;
    address?: string;
    zipcode?: string;
    city?: string;
    phone?: string;
    mobile?: string;
    email?: string;
    ean?: string;
    fax?: string;
    cvr?: string;
    logo?: string;
  }